import {pushDataLayer} from '@optimaxdev/analytics/mobile';

export const placeOfInteraction = {
    HP_SHOP_THE_LOOK: 'HP - Shop the look',
    CATEGORY_SIMILAR_FRAMES_HEART_ICON: 'Category - Similar Frames PopUp',
    CATEGORY_HEART_ICON: 'Category - Product',
    PDP_HEART_ICON: 'PDP - Product',
    PDP_CTA: 'PDP - CTA',
    WISHLIST: 'Wishlist',
    QUIZ: 'Quiz',
};

/**
 * A function to send EEC analytics for Wishlist actions
 * @param {number} sku - product sku
 * @param {string} source - place of interaction
 * @param {Function} createAnalyticsEvent - add/remove create event function
 */
export function sendWishListAnalytics(sku: string, source: string, createAnalyticsEvent) {
    pushDataLayer(createAnalyticsEvent({product: {id: sku}, source}));
}
